export interface GameConsole {
  id: string; // unique slug
  name: string; // display name
  emoji: string; // tile glyph (fallback when logo is missing/404s)
  logo?: string; // path to console wordmark SVG under /public
  logoPlate?: "light" | "dark"; // label backing on dark tiles; "dark" for white wordmarks (Genesis, SMS). default "light"
  core: string; // EJS_core system string
  accept: string; // file input accept attr
}

// `core` is the EmulatorJS *system* string (EmulatorJS maps system → libretro
// core internally), NOT the libretro core name. `gb` and `gbc` both use the
// `gb` core — the gambatte core handles Game Boy and Game Boy Color.
export const consoles: GameConsole[] = [
  { id: "nes", name: "Nintendo (NES)", emoji: "🕹️", logo: "/logos/nes.svg", core: "nes", accept: ".nes" },
  { id: "snes", name: "Super Nintendo", emoji: "🎮", logo: "/logos/snes.svg", core: "snes", accept: ".sfc,.smc" },
  { id: "gb", name: "Game Boy", emoji: "👾", logo: "/logos/gb.svg", core: "gb", accept: ".gb" },
  { id: "gbc", name: "Game Boy Color", emoji: "🌈", logo: "/logos/gbc.svg", core: "gb", accept: ".gbc" },
  { id: "gba", name: "Game Boy Advance", emoji: "🟣", logo: "/logos/gba.svg", core: "gba", accept: ".gba" },
  { id: "genesis", name: "Sega Genesis", emoji: "🦔", logo: "/logos/genesis.svg", logoPlate: "dark", core: "segaMD", accept: ".md,.gen,.smd,.bin" },
  { id: "sms", name: "Master System", emoji: "🎰", logo: "/logos/sms.svg", logoPlate: "dark", core: "segaMS", accept: ".sms" },
  { id: "gamegear", name: "Game Gear", emoji: "📟", logo: "/logos/gamegear.svg", core: "segaGG", accept: ".gg" },
  { id: "pce", name: "PC Engine / TG-16", emoji: "💳", logo: "/logos/pce.svg", core: "pce", accept: ".pce" },
  { id: "vb", name: "Virtual Boy", emoji: "🥽", logo: "/logos/vb.svg", core: "vb", accept: ".vb,.vboy" },
  { id: "atari2600", name: "Atari 2600", emoji: "🛸", logo: "/logos/atari2600.svg", core: "atari2600", accept: ".a26,.bin" },
  { id: "atari7800", name: "Atari 7800", emoji: "🚀", logo: "/logos/atari7800.svg", core: "atari7800", accept: ".a78" },
  { id: "lynx", name: "Atari Lynx", emoji: "🐱", logo: "/logos/lynx.svg", core: "lynx", accept: ".lnx" },
  { id: "ngp", name: "NeoGeo Pocket", emoji: "🎱", logo: "/logos/ngp.svg", core: "ngp", accept: ".ngp,.ngc" },
  { id: "ws", name: "WonderSwan", emoji: "🦢", logo: "/logos/ws.svg", core: "ws", accept: ".ws,.wsc" },
];
